module.exports = __webpack_public_path__ + "static/media/bar_under_english.ad041d4c.png";